/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'

// material-ui
import {
  CardActionArea,
  Card,
  CardContent,
  Typography,
  Hidden,
  CardMedia,
  withStyles,
} from '@material-ui/core'

// custom components
import Link from '../Links/Link'

// Data query function
import useLatestProject from '../../data/useLatestProject'

const styles = {
  card: {
    display: 'flex'
  },
  cardDetails: {
    flex: 1
  },
  cardMedia: {
    width: 160
  }
}

/**
 * Render latest project.
 * @param {Object} props - component properties
 * @param {Object} props.classes - override the injected class names
 * @returns {*}
 * @constructor
 */
function LatestProject({ classes }) {
  const {
    node: {
      excerpt,
      timeToRead,
      fields: { slug },
      frontmatter: { title, date }
    }
  } = useLatestProject()

  return (
    <CardActionArea component={Link} to={slug}>
      <Card className={classes.card}>
        <div className={classes.cardDetails}>
          <CardContent>
            <Typography variant="caption">Latest project</Typography>
            <Typography variant="h5" color="inherit">
              {title}
            </Typography>
            <Typography component="div" variant="caption" color="textSecondary">
              {date}
            </Typography>
            <Typography component="div" variant="caption" color="textSecondary" gutterBottom>
              {timeToRead + ' minutes'}
            </Typography>
            <Typography variant="subtitle2" paragraph>
              {excerpt}
            </Typography>
            <Typography variant="subtitle2" color="secondary">
              Continue reading...
            </Typography>
          </CardContent>
        </div>
        <Hidden xsDown>
          <CardMedia
            className={classes.cardMedia}
            image="https://source.unsplash.com/weekly?summer"
            title="Image title"
          />
        </Hidden>
      </Card>
    </CardActionArea>
  )
}

export default withStyles(styles)(LatestProject)
